module.exports = __webpack_public_path__ + "static/media/Mandrake.fff022c5.webp";